import { HttpResponseCodes } from '../http/axios/response';
import I18n from '../i18n';

import request from '@module/http/axios/request';

export default function Apify(setup) {
  // This method generates requests based on the setup
  function generateRequest(config) {
    return function generateApi(params = null, options = {}) {
      if (!config) {
        throw new Error('InvalidApiCall');
      }

      // Figure out parameters
      let path = config.path;

      // Do we like to extend/replace the path with a variable?
      if (config && config.pathExt && options.pathExtValues) {
        Object.keys(options.pathExtValues).forEach((pathExtName) => {
          path = path.replace(
            `{${pathExtName}}`,
            options.pathExtValues[pathExtName]
          );
        });
      }

      return request({
        method: config.method,
        path,
        params,
      }).catch((error) => {
        if (error.status === HttpResponseCodes.UNAUTHORIZED) {
          // eslint-disable-next-line no-alert
          alert(I18n.t('notification.logged_out'));
          location.reload();
          return;
        }

        // Throw the error again to continue execution, as this error will be caught
        // in other parts of the code.
        throw error;
      });
    };
  }

  // Create an object for all these API calls
  const transformed = {};

  // Loop through all the calls.
  const calls = Object.keys(setup);
  for (const call of calls) {
    transformed[call] = generateRequest(setup[call]);
  }

  return transformed;
}
